module.exports = __webpack_public_path__ + "media/images/icons/flags/TJ-761192171320bdbe92b611716f7bce2f.svg";